export default (user) => {
    let name="";
    if ((user.name || user.family)){
        if (user.name){
            name = user.name;
        }
        if (user.family){
            if (name){
                name += ` ${user.family}`;
            }else {
                name += user.family;
            }
        }
    }
    else if (user.country_code && user.phone_number){
        name = `${user.country_code.code}-${user.phone_number}`;
    }
    return name;

}